import axios from "axios";

export default {
  namespaced: true,
  state: {
    all_leads: [],
    deleted_leads: [],
    sales_agents: [],
    follow_up_leaderboard: [],
    // Global Leads settings — the default-hat filter applied to every account.
    lead_settings: { default_hat_id: null },
  },
  getters: {
    all_leads: (state) => state.all_leads,
    deleted_leads: (state) => state.deleted_leads,
    sales_agents: (state) => state.sales_agents,
    follow_up_leaderboard: (state) => state.follow_up_leaderboard,
    lead_settings: (state) => state.lead_settings,
    default_hat_id: (state) =>
      state.lead_settings ? state.lead_settings.default_hat_id : null,
  },
  mutations: {
    SET_ALL_LEADS(state, data) {
      state.all_leads = data;
    },
    SET_DELETED_LEADS(state, data) {
      state.deleted_leads = data;
    },
    SET_SALES_AGENTS(state, data) {
      state.sales_agents = data;
    },
    SET_LEAD_SETTINGS(state, data) {
      state.lead_settings = data || { default_hat_id: null };
    },
    SET_FOLLOW_UP_LEADERBOARD(state, data) {
      state.follow_up_leaderboard = data || [];
    },
    ADD_LEAD(state, lead) {
      state.all_leads.unshift(lead);
    },
    UPDATE_LEAD(state, lead) {
      const index = state.all_leads.findIndex((l) => l.id == lead.id);
      if (index !== -1) state.all_leads.splice(index, 1, lead);
    },
    REMOVE_LEAD(state, id) {
      state.all_leads = state.all_leads.filter((l) => l.id != id);
    },
  },
  actions: {
    async get_all_leads({ commit }, params = {}) {
      const response = await axios.get("/leads", { params });
      commit("SET_ALL_LEADS", response.data);
      return response.data;
    },
    async get_deleted_leads({ commit }) {
      const response = await axios.get("/deleted_leads");
      commit("SET_DELETED_LEADS", response.data);
      return response.data;
    },
    async get_lead(_, id) {
      const response = await axios.get("/lead/" + id);
      return response.data;
    },
    async add_lead({ commit }, lead) {
      const response = await axios.post("/lead", lead);
      commit("ADD_LEAD", response.data);
      return response.data;
    },
    async update_lead({ commit }, lead) {
      const response = await axios.put("/lead", lead);
      commit("UPDATE_LEAD", response.data);
      return response.data;
    },
    async delete_lead({ commit }, id) {
      await axios.delete("/lead/" + id);
      commit("REMOVE_LEAD", id);
    },
    async restore_lead(_, id) {
      const response = await axios.post("/lead/" + id + "/restore");
      return response.data;
    },
    async add_activity(_, { id, activity }) {
      const response = await axios.post("/lead/" + id + "/activity", activity);
      return response.data;
    },
    async mark_won({ commit }, { id, invoice_id }) {
      const response = await axios.post("/lead/" + id + "/mark_won", {
        invoice_id,
      });
      commit("UPDATE_LEAD", response.data);
      return response.data;
    },
    async mark_lost({ commit }, { id, lost_reason }) {
      const response = await axios.post("/lead/" + id + "/mark_lost", {
        lost_reason,
      });
      commit("UPDATE_LEAD", response.data);
      return response.data;
    },
    async get_sales_agents({ commit }) {
      const response = await axios.get("/sales_agents");
      commit("SET_SALES_AGENTS", response.data);
      return response.data;
    },
    async get_follow_up_leaderboard({ commit }, params = {}) {
      const response = await axios.get("/leads/follow_up_leaderboard", {
        params,
      });
      commit("SET_FOLLOW_UP_LEADERBOARD", response.data);
      return response.data;
    },
    async get_lead_settings({ commit }) {
      const response = await axios.get("/lead_settings");
      commit("SET_LEAD_SETTINGS", response.data);
      return response.data;
    },
    async update_lead_settings({ commit }, payload) {
      const response = await axios.put("/lead_settings", payload);
      commit("SET_LEAD_SETTINGS", response.data);
      return response.data;
    },
  },
};
